import { link, tokenLink, dnsPortal, urlADM } from "../../services/variables";

//alguns link possuem token diferente do padrão
const linksNavbar = [
  // Município
  {
    name: `O SAAE`,
    top_list: true,
    img: "Municipio",
    sub_link: [
      {
        name: `SAAE`,
        link: `/redes-sociais`,
      },
      {
        name: `Distâncias`,
        link: `/municipio/distancias`,
      },
      /* {
        name: `História`,
        link: `/municipio/historia`,
      }, */
      /* {
        name: `População`,
        link: `/municipio/populacao`,
      }, */
      {
        name: `Mapa`,
        link: `/municipio/mapa`,
      },
      // {
      //   name:`Símbolos`,
      //   link:`/municipio/simbolos`
      // },
      {
        name: `Endereços Úteis`,
        link: `/municipio/enderecos-uteis`,
      },
      // {
      //   name:`Distritos`,
      //   link:`/municipio/distritos`
      // },
      // {
      //   name:`Eventos`,
      //   link:`/municipio/eventos`
      // },
      // {
      //   name: `Obras`,
      //   link: `${link}/portaltm/licitacao/obrapublica.xhtml?token=${tokenLink}`,
      // },
      // {
      //   name:`Veículos`,
      //   link:`/municipio/veiculos`
      // },
    ],
  },
  // Serviços
  {
    name: `Serviços`,
    top_list: true,
    img: "services",
    sub_link: [
      /* {
        name: `Nota Fiscal Eletrônica`,
        link: `#`,
      },
      {
        name: `Contracheque`,
        link: `#`,
      }, */
      {
        name: `Agência Virtual - 2ª Via`,
        link: `https://codo.agenciavirtual.gestaosaneamentoweb.com.br/`,
      },
      {
        name: `Tarifas e Serviços`,
        link: `/tarifas-e-servicos`,
      },
    ],
  },
  {
    name: `Informações Institucionais`,
    top_list: true,
    img: "Institucional",
    sub_link: [
      {
        name: `Registro das Competências`,
        link: `/informacoes-institucionais/registro-das-competencias`,
      },
      // {
      //   name: `Mural`,
      //   link: `/informacoes-institucionais/mural`,
      // },
      /* {
        name: `Estrutura Organizacional`,
        // link: `${link}/portal/organograma/organograma.xhtml?token=${tokenLink}`,
        link: `/estrutura-organizacional`,
      },
      {
        name: `Leis Municipais / Estaduais`,
        sub_link: [
          {
            name: `Lei Orgânica`,
            //versão interna
            // link: `/legislativo-municipal/legislacao/lei-organica`,
            link: `${urlADM}/admpublica/lei-organica?token=${tokenLink}`,
          },
          {
            name: `Código Tributário`,
            link: `${urlADM}/admpublica/codigo-tributario?token=${tokenLink}`,
            // link: `/informacoes-institucionais/leis-municipais/estaduais/codigo-tributario`,
          },
          {
            name: `Leis Municipais`,
            // link: `/informacoes-institucionais/leis-municipais/estaduais/lei`,
            link: `${urlADM}/admpublica/lei?token=${tokenLink}`,
          },
          {
            name: `Leis Estaduais`,
            link: `${urlADM}/acesso-a-informacao?token=${tokenLink}`,
          },
          {
            name: `Projeto de Leis`,
            link: `/informacoes-institucionais/leis-municipais/estaduais/projeto-de-lei`,
          },
          {
            name: `Decretos `,
            // link: `/informacoes-institucionais/leis-municipais/estaduais/decreto`,
            link: `${urlADM}/admpublica/decreto?token=${tokenLink}`,
          },
          {
            name: `Portarias`,
            //versão conjunta
            link: `${urlADM}/admpublica/portarias?token=${tokenLink}`,
          },
          {
            name: `Outros Atos Administrativos `,
            // link: `/informacoes-institucionais/leis-municipais/estaduais/outros-atos-administrativos`,
            link: `${urlADM}/admpublica/outros-atos-administrativos?token=${tokenLink}`,
          },
        ],
      }, */
      {
        name: "Concursos / Seletivos",
        link: `${urlADM}/licitacoes-e-contratos/concurso?token=${tokenLink}`,
      },
      /*  {
         name: "Conselhos Municipais",
         link: `${urlADM}/admpublica/conselhos-municipais?token=${tokenLink}`,
       }, */
      {
        name: `Fale Conosco`,
        link: `${urlADM}/ouvidoria?token=${tokenLink}`,
      },
    ],
  },
  // Diário Oficial
  {
    name: `Diário Oficial`,
    top_list: true,
    img: "Diario_OFI",
    // link: `${urlADM}/diario-oficial?token=${tokenLink}`,
    link: `${urlADM}/diario-oficial?token=62a5914b369817a999c77f98eed79c7db7161d7e`,
  },
  // Pessoal
  {
    name: `Pessoal`,
    top_list: true,
    img: "Pessoal",
    sub_link: [
      {
        name: `Estatuto do Servidor`,
        link: `${urlADM}/admpublica/estatuto-dos-servidores?token=${tokenLink}`,
      },
      {
        name: `Folha de pagamento`,
        link: `${urlADM}/v2/folhadomaranhao?token=${tokenLink}`,
        // link: `${urlADM}/v2/folhadopiaui?token=${tokenLink}`,
      },
      {
        name: `Relação Nominal de cada servidor`,
        // link: `/pessoal/remuneracao-nominal-de-cada-servidor`,
        link: `${urlADM}/admpublica/relacao-nominal-de-cada-servidor?token=${tokenLink}`,
      },
      {
        name: `Servidores inativos`,
        // link: `/pessoal/relacao-de-servidores-inativos`,
        link: `${urlADM}/admpublica/relacao-de-servidores-inativos?token=${tokenLink}`,
      },
      {
        name: `Servidores ocupante de cargo em comissão`,
        // link: `/pessoal/relacao-de-servidores-ocupantes-de-cargo-em-comissao`,
        link: `${urlADM}/admpublica/relacao-de-servidores-ocupantes-de-cargo-em-comissao?token=${tokenLink}`,
      },
      {
        name: `Servidores cedidos para outros Órgãos Públicos`,
        // link: `/pessoal/relacao-de-servidores-cedidos-para-outros-orgaos-publicos`,
        link: `${urlADM}/admpublica/relacao-de-servidores-cedidos-para-outros-orgaos-publicos?token=${tokenLink}`,
      },
      {
        name: `Relação nominal dos estagiários`,
        // link: `/pessoal/relacao-nominal-dos-estagiarios`,
        link: `${urlADM}/admpublica/relacao-nominal-dos-estagiarios?token=${tokenLink}`,
      },
      {
        name: `Relação de contratados temporariamente e contratos de terceirização`,
        link: `${urlADM}/admpublica/relacao-nominal-dos-agentes-publicos-contratados-temporariamente-e-contratados-de-terceirizacao?token=${tokenLink}`,
      },
      {
        name: `Tabela com o padrão remuneratório dos cargos e função`,
        link: `${urlADM}/admpublica/tabela-remuneratoria-dos-cargos-e-funcoes?token=${tokenLink}`,
      },
    ],
  },
  // Diárias
  {
    name: `Diárias`,
    top_list: true,
    img: "Diárias",
    sub_link: [
      {
        name: `Relação das Diárias`,
        link: `${urlADM}/admpublica/relacao-das-diarias-dentro-e-fora-estado-e-fora-do-pais?token=${tokenLink}`,
      },
      {
        name: `Diárias e Passagens`,
        link: `http://dcscpi.adtrcloud.com.br:8062/SAAECODO/Default.aspx?AcessoIndividual=lnkDiarias`,
      },
      {
        name: `Legislação`,
        link: `${urlADM}/admpublica/diarias-e-legislacao?token=${tokenLink}`,
      },
    ],
  },
  // Transparência
  {
    name: `Transparência`,
    link: `/transparencia`,
    top_list: true,
    img: "Transparência",
  },
  // Licitações e Contratos
  {
    name: `Licitações e Contratos`,
    top_list: true,
    img: "licitaçoes",
    sub_link: [
      {
        name: `Plano Anual de Contratações`,
        link: `${urlADM}/admpublica/plano-anual-de-contratacoes?token=${tokenLink}`,
      },
      {
        name: `Indicação do Fiscal de Contrato`,
        link: `/licitacoes-e-contratos/indicacao-do-fiscal-do-contrato`,
      },
      {
        name: `Avisos`,
        link: `/licitacoes-e-contratos/avisos`,
      },
      {
        name: `Edital`,
        link: `/licitacoes-e-contratos/edital`,
      },
      {
        name: `Dispensas`,
        link: `/licitacoes-e-contratos/dispensas`,
      },
      {
        name: `Inexigibilidade`,
        link: `/licitacoes-e-contratos/inexigibilidade`,
      },
      {
        name: `Pregão Eletrônico`,
        link: `/licitacoes-e-contratos/pregao-eletronico`,
      },
      {
        name: `Adesão de Ata - SRP `,
        link: `/licitacoes-e-contratos/ata-de-adesao`,
      },
      {
        name: `Resultados do Certame`,
        link: `/licitacoes-e-contratos/resultado-do-certame`,
      },
      {
        name: `Desertas e Fracassadas`,
        link: `/licitacoes-e-contratos/desertas-fracassadas`,
      },
      {
        name: `Obras Públicas`,
        link: `/licitacoes-e-contratos/obras-publicas`,
      },
      {
        name: `Termo de Aditivo`,
        link: `/licitacoes-e-contratos/termo-de-aditivo`,
      },
      {
        name: `Convênio`,
        link: `/licitacoes-e-contratos/convenio`,
      },
      {
        name: `Contratos `,
        link: `/licitacoes-e-contratos/contrato`,
      },
      {
        name: `Fornecedores Sancionados`,
        link: `${urlADM}/licitacoes-e-contratos/fornecedores-sancionados?token=${tokenLink}`,
      },
    ],
  },
  // Ouvidoria
  {
    name: `Ouvidoria`,
    top_list: true,
    img: "Ouvidoria",
    sub_link: [
      {
        name: `Regulamentação`,
        link: `${urlADM}/admpublica/divisao/regulamentacao-da-ouvidoria?token=${tokenLink}`,
      },
      {
        name: `Atendimento Presencial`,
        link: `/ouvidoria/atendimento-presencial`,
      },
      {
        name: `Redes Sociais`,
        link: `/redes-sociais`,
      },
      {
        name: `Carta de Serviços ao Usuário`,
        link: `${urlADM}/admpublica/carta-de-servicos-ao-usuario?token=${tokenLink}`,
      },
      {
        name: `Canal Eletrônico de Acesso`,
        // link: `/ouvidoria/canal-eletronico-de-acesso`,
        link: `${urlADM}/ouvidoria?token=${tokenLink}`,
      },
      {
        name: `Perguntas e Respostas`,
        // link: `/ouvidoria/perguntas-e-respostas`,
        link: `${urlADM}/ouvidoria/acompanhamento?token=${tokenLink}`,
      },
      // {
      //   name:``,
      //   link:`/ouvidoria/`,
      // },

      // {
      //   name:`Detalhe`,
      //   link: `/ouvidoria/detalhe`
      // },
    ],
  },
  // Cidadão | e-SIC
  {
    name: `Cidadão | e-SIC `,
    top_list: true,
    img: "Cidadão",
    sub_link: [
      {
        name: `e-SIC - Regulamentação`,
        link: `${urlADM}/esic?token=${tokenLink}`,
      },
      {
        name: `e-SIC - Perguntas e Respostas`,
        link: `${urlADM}/e-sic/perguntas-e-respostas?token=${tokenLink}`,
      },
      {
        name: `e-SIC`,
        link: `${urlADM}/e-sic?token=${tokenLink}`,
      },
      {
        name: `Portaria do responsável pelo e-SIC`,
        link: `${urlADM}/admpublica/divisao/regulamentacao-esic?token=${tokenLink}`,
      },
      {
        name: `Instrumento normativo local que regulamente a LAI`,
        link: `${urlADM}/acesso-a-informacao?token=${tokenLink}`,
      },
      {
        name: `e-SIC - Rol de Informações (12 meses)`,
        link: `${urlADM}/admpublica/rol-das-informacoes-que-tenham-sido-desclassificadas-nos-ultimos-12-doze-meses?token=${tokenLink}`,
      },
      {
        name: `e-SIC - Rol de documentos (Grau Sigilo)`,
        link: `${urlADM}/admpublica/rol-de-documentos-classificados-em-cada-grau-de-sigilo-com-identificacao-para-referencia-futura?token=${tokenLink}`,
      },
    ],
  },
  {
    name: `LGPD`,
    top_list: true,
    img: "lgpd",
    link: `${urlADM}/lgpd?token=${tokenLink}`,
  },
  // Usuário
  {
    name: `Usuário`,
    top_list: true,
    img: "admin-navbar",
    sub_link: [
      {
        name: `Login - Portal`,
        link: `https://noticias.administracaopublica.com.br/auth/login`,
      },
      {
        name: `Login - Diário`,
        link: `${link}/diario/login.xhtml`,
      },
      {
        name: `Login - Licitação`,
        link: `${link}/licitacaotm/login.xhtml`,
      },
      {
        name: `Login - Atendimento`,
        link: `https://atendimento.administracaopublica.com.br/auth/login`,
      },
      {
        name: `WebMail`,
        link: `webmail.${dnsPortal}`,
      },
    ],
  },
];
export default linksNavbar;
